export class EquipmentUsage {
  usageQuantity: number;
  usageTypeId: number;
}
